// extracted by mini-css-extract-plugin
module.exports = {"body":"About_body__pC7UL","title":"About_title__24szz","subtitle":"About_subtitle__2Xw0W","spacecol":"About_spacecol__2ZqV5"};